// src/components/settings/NotificationsSection.jsx
import { useState } from 'react';
import { toast } from 'react-toastify';
import SettingsCard from './ui/SettingsCard';
import s from './section.module.css';
import ns from './NotificationsSection.module.css';

const PREFS_KEY = 'nessefy_notif_prefs';

const DEFAULT_PREFS = {
  // In-app
  likes:         true,
  comments:      true,
  follows:       true,
  messages:      true,
  chatRequests:  true,
  postShares:    true,
  mentions:      true,
  systemUpdates: true,
  // Email
  emailLikes:    false,
  emailComments: true,
  emailFollows:  true,
  emailMessages: false,
};

function loadPrefs() {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    return raw ? { ...DEFAULT_PREFS, ...JSON.parse(raw) } : { ...DEFAULT_PREFS };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

//  Toggle switch component 
function Toggle({ checked, onChange }) {
  return (
    <button
      role="switch"
      aria-checked={checked}
      className={`${ns.toggle} ${checked ? ns.toggleOn : ''}`}
      onClick={() => onChange(!checked)}
      type="button"
    >
      <span className={ns.knob} />
    </button>
  );
}

//  Single pref row 
function PrefRow({ label, sublabel, checked, onChange, last }) {
  return (
    <div className={`${ns.row} ${last ? ns.rowLast : ''}`}>
      <div className={ns.info}>
        <div className={ns.label}>{label}</div>
        {sublabel && <div className={ns.sub}>{sublabel}</div>}
      </div>
      <Toggle checked={checked} onChange={onChange} />
    </div>
  );
}

// 
export default function NotificationsSection() {
  const [prefs, setPrefs] = useState(loadPrefs);
  const set = key => val => setPrefs(p => ({ ...p, [key]: val }));

  const handleSave = () => {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
    toast.success('Notification preferences saved!');
  };

  const handleReset = () => {
    setPrefs({ ...DEFAULT_PREFS });
    localStorage.removeItem(PREFS_KEY);
    toast.info('Notification preferences reset to default.');
  };

  return (
    <>
      {/*  In-app notifications  */}
      <SettingsCard
        title="In-App Notifications"
        subtitle="Choose what you get notified about inside Nessefy."
      >
        <PrefRow label="Likes"           sublabel="When someone likes your post."              checked={prefs.likes}         onChange={set('likes')} />
        <PrefRow label="Comments"        sublabel="When someone comments on your post."        checked={prefs.comments}      onChange={set('comments')} />
        <PrefRow label="New Followers"   sublabel="When someone follows you."                 checked={prefs.follows}       onChange={set('follows')} />
        <PrefRow label="Messages"        sublabel="New direct messages."                       checked={prefs.messages}      onChange={set('messages')} />
        <PrefRow label="Chat Requests"   sublabel="New connection requests in chat."           checked={prefs.chatRequests}  onChange={set('chatRequests')} />
        <PrefRow label="Post Shares"     sublabel="When someone shares your post."             checked={prefs.postShares}    onChange={set('postShares')} />
        <PrefRow label="Mentions"        sublabel="When someone mentions you."                 checked={prefs.mentions}      onChange={set('mentions')} />
        <PrefRow label="Nessefy Updates" sublabel="Platform announcements and new features."  checked={prefs.systemUpdates} onChange={set('systemUpdates')} last />
      </SettingsCard>

      {/*  Email notifications  */}
      <SettingsCard
        title="Email Notifications"
        subtitle="Control what Nessefy sends to your inbox."
      >
        <PrefRow label="Likes via Email"     sublabel="Get emailed when your post is liked."     checked={prefs.emailLikes}    onChange={set('emailLikes')} />
        <PrefRow label="Comments via Email"  sublabel="Get emailed on new comments."             checked={prefs.emailComments} onChange={set('emailComments')} />
        <PrefRow label="New Followers via Email" sublabel="Get emailed when someone follows you." checked={prefs.emailFollows}  onChange={set('emailFollows')} />
        <PrefRow label="Messages via Email"  sublabel="Get emailed for new direct messages."     checked={prefs.emailMessages} onChange={set('emailMessages')} last />
      </SettingsCard>

      <div className={s.btnRow}>
        <button className={s.btnPrimary} onClick={handleSave}>Save Preferences</button>
        <button className={s.btnOutline} onClick={handleReset}>Reset to Default</button>
      </div>
    </>
  );
}